import { render, staticRenderFns } from "./SelectPopover.vue?vue&type=template&id=97aa50ce&scoped=true"
import script from "./SelectPopover.vue?vue&type=script&lang=js"
export * from "./SelectPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aa50ce",
  null
  
)

export default component.exports